/**
 * Profile Page Helpers
 * Utility functions for badges, levels, and formatting
 */

import type { LevelIconType } from '../types';
import { LEVEL_ICONS } from './constants';

/**
 * Get the icon type for a given level
 */
export function getLevelIconType(level: number): LevelIconType {
  return LEVEL_ICONS[level] || 'medal';
}

/**
 * Format XP value with locale string
 */
export function formatXp(xp: number): string {
  return xp.toLocaleString();
}

/**
 * Format distance in miles
 */
export function formatDistance(miles: number): string {
  if (miles < 1) {
    return '< 1 mi';
  }
  return `${Math.round(miles)} mi`;
}

/**
 * Format store address from store data
 */
export function formatStoreAddress(city: string, state: string): string {
  return `${city}, ${state}`;
}

/**
 * Parse a date string to localized date
 */
export function formatBadgeDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString();
}

/**
 * Validate US zipcode format
 */
export function isValidZipcode(zipcode: string): boolean {
  return /^\d{5}$/.test(zipcode);
}

/**
 * Calculate XP progress percentage
 */
export function calculateXpProgress(currentXp: number, requiredXp: number): number {
  if (requiredXp <= 0) return 100;
  return Math.min(100, Math.round((currentXp / requiredXp) * 100));
}
